import React from 'react';

export default function Footer({ handleClick }) {
  return (
    <div className="footer">
      <div className="footer-btn" tabIndex={0} onClick={() => handleClick('home')} role="button">HOME</div>
      <div className="footer-btn" tabIndex={0} onClick={() => handleClick('stores')} role="button">NEGOZI</div>
      <div className="footer-btn" tabIndex={0} onClick={() => handleClick('loyaltycard')} role="button">CARTA FEDELTÀ</div>
      <div className="footer-btn" tabIndex={0} onClick={() => handleClick('shipping')} role="button">SPEDIZIONI</div>
    </div>
  );
}
